import { useEffect, useState } from "react";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";

import "./EditEventModal.css";

const EditEventModal = ({ isOpen, onClose, event, onSave }) => {
  const { t } = useLanguage();
  const [form, setForm] = useState({
    name: "",
    date: "",
    time: "",
    description: "",
    location: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (event) {
      setForm({
        name: event.name || "",
        date: event.date || "",
        time: event.time || "",
        description: event.description || "",
        location: event.location || "",
      });
    }
  }, [event]);

  if (!isOpen || !event) return null;

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      await onSave({ id: event.id, ...form });
      onClose();
    } catch (err) {
      setError(err?.message || "Failed to update event");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="edit-event-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="edit-event-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-event-header">
          <h3 className="edit-event-title">{t("dashboard.editEvent.title")}</h3>
          <button className="edit-event-close" onClick={onClose} aria-label="Close">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="edit-event-body">
            {error && (
              <div style={{background:'#fee',border:'1px solid #fcc',color:'#b91c1c',padding:10,borderRadius:8,marginBottom:10}}>
                {error}
              </div>
            )}
            <div className="edit-event-grid">
              <div className="edit-event-field full">
                <label htmlFor="name">{t("eventCreate.form.name")}</label>
                <input id="name" name="name" value={form.name} onChange={onChange} required />
              </div>
              <div className="edit-event-field">
                <label htmlFor="date">{t("eventCreate.form.date")}</label>
                <input id="date" type="date" name="date" value={form.date} onChange={onChange} required />
              </div>
              <div className="edit-event-field">
                <label htmlFor="time">{t("eventCreate.form.time")}</label>
                <input id="time" type="time" name="time" value={form.time} onChange={onChange} required />
              </div>
              <div className="edit-event-field full">
                <label htmlFor="description">{t("eventCreate.form.description")}</label>
                <textarea id="description" name="description" value={form.description} onChange={onChange} rows={3} />
              </div>
              <div className="edit-event-field full">
                <label htmlFor="location">{t("eventCreate.form.location")}</label>
                <input id="location" name="location" value={form.location} onChange={onChange} />
              </div>
            </div>
          </div>
          <div className="edit-event-footer">
            <button type="button" className="btn secondary" onClick={onClose}>{t("commons.cancel") || "Cancel"}</button>
            <button type="submit" className="btn primary" disabled={saving}>{saving ? (t("commons.saving") || "Saving...") : (t("commons.save") || "Save")}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEventModal;
